/*
 * Copyright (c) Sureify Labs 2020.
 * This source code is licensed under MIT License.
 * @author jayendrasharan <jayendra@sureify.com>
 * Created at: 03/05/20, 8:00 AM
 * Last Modified at: 03/05/20, 8:00 AM
 */
import styled from 'styled-components'
import { themes } from '../../themes'

const CCRadioSize = '22px'

const vars = {
  classic: {
    height: '2em'
  },
  oval: {
    height: '2em'
  },
  rectangle: {
    height: '2em'
  },
  icon_card: {
    height: 'auto'
  },
  card: {
    height: 'auto'
  },
  card_columns: {
    height: 'auto'
  },
  card_button: {
    height: 'auto'
  },
  product_card: {
    height: 'auto'
  },
  htmlRadioButton: {
    height: '2em'
  }
}

const CardTitle = styled.div`
  background: rgba(226, 226, 226, 1);
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  ${({ theme }) => !theme.hasBorderTop && 'min-height: 90px;'}
  // https://stackoverflow.com/a/54796082
  &:after {
    content: '';
    min-height: inherit;
  }
  ${({ theme }) =>
    theme.hasBorderTop &&
    `
  height: 144px;
  flex-direction: column;
  background: ${theme.bgColor};
  color: ${theme.fontColor};
  border: 1px solid #b9c6d3;
  border-bottom: none;
  width:100%;
  `}
`

const CardBody = styled.div`
  height: 140px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: rgba(69, 69, 69, 1);
  ${({ theme }) =>
    theme.hasBorderTop &&
    `background-color: ${theme.checkedFg};
    border: none;
    color: ${theme.checkedFg};
    & ${Val} {
    font-size: 54px;
    @media (max-width: 1023px) {
      font-size:48px;
    }
    @media (max-width: 780px) {
      font-size:18px;
    }
    @media (max-width: 350px) {
      font-size:15px;
    }
    }
    & ${Value} {
      margin:0;
      }
    & ${Metric} {
      font-size: 24px;
      margin-bottom:10px;
      @media (max-width: 780px) {
        font-size:18px;
        margin-bottom:0;
      }
      @media (max-width: 350px) {
        font-size:12px;
        margin-bottom:0;
      }
      }
    & ${Heading} {
      font-size: 20px;
      margin-top:15px;
      text-align:center;
      @media (max-width: 780px) {
        font-size:18px;
      }
      @media (max-width: 350px) {
        font-size:16px;
      }
      }
    & ${Prefix} {
      font-size: 30px;
      margin-top: 10px;
      @media (max-width: 780px) {
        margin-top:0;
        font-size:12px;
      }
      }
    `}
`
const CardArrow = styled.span`
  width: 100%;
  align-items: center;
  justify-content: center;
  display: flex;
  height: 0;
  &:after {
    display: none;
    position: relative;
    top: 14px;
    left: 0;
    right: 0;
    bottom: 0;
    content: '';
    width: 0px;
    height: 0px;
    ${({ theme }) => `border-top: 14px solid ${theme.checkedBg};`}
    border-left: 14px solid transparent;
    border-right: 14px solid transparent;
    border-bottom: 14px solid transparent;
  }
`

const Value = styled.div`
  font-size: 26px;
  margin: 5px 0;
`

const Heading = styled.div`
  font-size: 14px;
`

const Prefix = styled.div`
  font-size: 20px;
  align-self: flex-start;
  margin-top: 4px;
  @media (max-width: 780px) {
    margin-top: 2px;
    font-size: 12px;
  }
  @media (max-width: 350px) {
    font-size: 10px;
  }
`

const Val = styled.div`
  font-size: 28px;
  @media (max-width: 780px) {
    font-size: 18px;
  }
  @media (max-width: 350px) {
    font-size: 15px;
  }
`

const Metric = styled.div`
  font-size: 14px;
  ${({ theme }) =>
    theme.hasBorderTop &&
    `
  font-size: 20px;
  margin-left:5px;
  margin-bottom:3px;
  @media (max-width: 780px) {
    font-size: 14px;
    margin-left:3px;
    margin-bottom:2px;
  }
  @media (max-width: 350px) {
    font-size: 12px;
    margin-left:3px;
    margin-bottom:2px;
  }
  `}
`

const CardWrapper = styled.div`
  border: 1px solid rgba(215, 215, 215, 1);
  &:hover ${CardTitle} {
    color: ${({ theme }) =>
      theme.hasBorderTop
        ? !theme.disabled && theme.checkedFg
        : !theme.disabled && '#ffffff'};
    background: ${({ theme }) => !theme.disabled && theme.checkedBg};
    ${({ theme }) =>
      theme.hasBorderTop && !theme.disabled && `border-top: ${theme.border};`}
    font-weight: ${({ theme }) => !theme.disabled && theme.fontWeight};
  }
  ${({ theme }) => theme.hasBorderTop && `border: none;`}
  & ${CardTitle} ${Value} {
    ${({ theme }) => theme.hasBorderTop && `font-size: 20px;`}
  }
  & ${CardBody} ${Value} {
    ${({ theme }) => theme.hasBorderTop && `font-size: 22px;`}
  }
  width: 100%;
  font: ${({ theme }) => theme.font};
`
const FakeInput = styled.span`
  position: absolute;
  height: 20px;
  width: 20px;
  background: ${({ theme }) => theme.fillBg};
  border-radius: 50%;
  display: ${({ theme }) =>
    theme.shape === 'classic' || theme.showCustomInput ? 'block' : 'none'};
  &:after {
    display: none;
  }
  &:after {
    content: '';
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: ${({ theme }) =>
      theme.showCustomInput ? theme.checkedBg : theme.checkedFg};
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
  ${({ theme }) =>
    theme.showCustomInput &&
    `
  margin-left:12px;
`}
`

const ProductCardDetail = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: start;
  padding: 25px 5px 5px 5px;
  background-color: white;
  cursor: pointer;
`

const ProductIcon = styled.div`
  height: 100%;
  width: 100%;
  background-image: url(${({ url }) => url});
`

const ProductIconWrapper = styled.div`
  position: absolute;
  top: -50px;
  left: calc(50% - 50px);
  height: 100px;
  width: 100px;
  border-radius: 50%;
  border: 2px solid;
  border-color: ${({ theme }) =>
    theme.unCheckedColor ? theme.unCheckedColor : '#a1a1a1'};
  overflow: hidden;
  background-color: #f5f5f5;
  display: flex;
  justify-content: center;
  align-items: center;
`

const Title = styled.h2`
  font-size: 25px;
  color: #a1a1a1;
  font-size: 20px;
  font-weight: bold;
  word-spacing: 0.5px;
  text-transform: capitalize;
  word-break: break-word;
`

const ProductDescription = styled.div`
  word-break: break-word;
`

const ProductContent = styled.div`
  text-align: start;
  padding: 25px 5px;
  max-width: 100%;
  height: ${({ isCollapsed }) => (isCollapsed ? '200px' : '350px')};
  overflow: ${({ isCollapsed }) => (isCollapsed ? 'hidden' : 'auto')};
  &::-webkit-scrollbar {
    width: 2px;
    height: 1px;
    background: transparent; /* Optional: just make scrollbar invisible */
  }
  /* Optional: show position indicator */
  &::-webkit-scrollbar-thumb {
    background: ${({ theme }) =>
      theme.unCheckedColor ? theme.unCheckedColor : '#a1a1a1'};
  }
`

const ViewMore = styled.button`
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  border: none;
  width: 100%;
  padding: ${({ isCollapsed }) => (isCollapsed ? '40px 0 5px 0' : '5px')};
  outline: none;
  font-size: 18px;
  word-spacing: 1px;
  letter-spacing: 1px;
  cursor: pointer;
  background: -webkit-linear-gradient(
    top,
    rgba(0, 0, 0, 0),
    rgba(255, 255, 255, 1)
  ); /* For Safari 5.1 to 6.0 */
  background: -o-linear-gradient(
    bottom,
    rgba(255, 255, 255, 0),
    rgba(255, 255, 255, 1)
  ); /* For Opera 11.1 to 12.0 */
  background: -moz-linear-gradient(
    bottom,
    rgba(255, 255, 255, 0),
    rgba(255, 255, 255, 1)
  ); /* For Firefox 3.6 to 15 */
  background: linear-gradient(
    to bottom,
    rgba(255, 255, 255, 0),
    rgba(255, 255, 255, 1),
    rgba(255, 255, 255, 1)
  ); /* Standard syntax (must be last) */
  background-color: ${({ isCollapsed }) => (isCollapsed ? 'none' : '#FFFFFF')};
`

const QuoteButtonWrapper = styled.div`
  height: 70px;
  padding: 8px 10px;
  width: 100%;
  display: flex;
  border-top: 3px solid;
  border-color: ${({ theme }) =>
    theme.unCheckedColor ? theme.unCheckedColor : '#a1a1a1'};
`

const QuoteButton = styled.div`
  display: flex;
  flex-grow: 1;
  outline: none;
  border: 3px solid transparent;
  border-radius: 5px;
  background-color: ${({ theme }) => theme.checkedBg};
  color: white;
  font-size: 20px;
  font-weight: bold;
  letter-spacing: 2px;
  text-transform: uppercase;
  justify-content: center;
  align-items: center;
`

const CheckMark = styled.div`
  position: relative;
  display: none;
  width: 30px;
  height: 30px;
  &:before {
    position: absolute;
    left: -2px;
    top: 50%;
    height: 55%;
    width: 7px;
    background-color: white;
    content: '';
    transform: translateX(10px) rotate(-45deg);
    transform-origin: left bottom;
    border-radius: 3px;
  }

  &:after {
    position: absolute;
    left: 0;
    bottom: 0;
    height: 7px;
    width: 100%;
    background-color: white;
    content: '';
    transform: translateX(10px) rotate(-45deg);
    transform-origin: left bottom;
    border-radius: 3px;
  }
`

const ProductCardWrapper = styled.div`
  border: 3px solid;
  border-color: ${({ theme }) =>
    theme.unCheckedColor ? theme.unCheckedColor : '#a1a1a1'};
  display: flex;
  flex-direction: column;
  align-self: flex-start;
  min-width: 280px;
  width: 350px;
  margin: 30px auto;
  &:hover {
    border: 3px solid;
    border-color: ${({ theme }) => theme.checkedBg};
    & ${ProductCardDetail} ${ProductIconWrapper} {
      background-color: ${({ theme }) => theme.checkedBg};
      border: inherit;

      & ${ProductIcon} {
        display: none;
      }
      & ${CheckMark} {
        display: inline-block;
        color: white;
      }
    }
    & ${QuoteButtonWrapper} {
      border-top: inherit;

      & ${QuoteButton} {
        border: 3px solid;
        border-color: ${({ theme }) => theme.checkedBg};
        background-color: white;
        color: ${({ theme }) => theme.checkedBg};
      }
    }
  }
`

const Input = styled.input`
  opacity: 0;
  position: absolute;
  width: 100%;

  &:checked ~ ${FakeInput} {
    ${({ theme }) =>
      theme.showCustomInput &&
      `
      z-index:2;
    `}
    background: ${({ theme }) =>
      theme.showCustomInput ? theme.checkedFg : theme.checkedBg};
  }
  &:checked ~ ${CardWrapper} ${CardTitle} {
    color: #ffffff;
    background: ${({ theme }) => theme.checkedBg};
    ${({ theme }) =>
      theme.hasBorderTop &&
      `border-top: ${theme.border}; color: ${theme.checkedFg};`}
    font-weight: ${({ theme }) => theme.fontWeight};
  }
  &:checked ~ ${CardWrapper} ${CardBody} {
    ${({ theme }) =>
      theme.hasBorderTop &&
      `background: ${theme.checkedFg}; color: ${theme.cardFontColor} !important;`}
    font-weight: ${({ theme }) => theme.fontWeight};
  }
  &:checked ~ ${CardWrapper} ${CardArrow} {
    ${({ theme }) =>
      theme.hasBorderTop &&
      `&:after {
      display: block;
    }`}
  }
  &:checked {
    & ~ ${FakeInput}:after {
      display: block;
    }
    & ~ span {
      ${({ theme }) =>
        theme.shape !== 'classic' &&
        `
        @media (-ms-high-contrast: active) {
          background: yellow;
          color: black;
        }

        background: ${theme.checkedBg};
        color: ${theme.checkedFg};
      `}
      ${({ theme }) =>
        theme.hasBorderTop &&
        `
       border-top:3px solid black;
      `}
      ${({ theme }) =>
        theme.showCustomInput &&
        `
      border:2px solid ${theme.checkedBg};
       box-shadow:inset 0px 0px 0px 1px ${theme.checkedFg};
       box-sizing:border-box;
       `}
       @-moz-document url-prefix() {
        ${(props) =>
          props.hcEnabled &&
          `
          background: white;
          color: white;
          text-decoration: underline;
          text-decoration-thickness: 5px;
        `}
      }
    }
  }
  &:checked ~ div.cb_wrapper {
    background: #00534c;
    box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.3);
    height: 100%;
    max-height: 264px;
    padding: 24px;
    & div.cb_title {
      color: #ffffff;
      @media (max-width: 767px) {
        font-size: 26px;
      }
    }
    & div.cb_subtitle {
      color: #ffffff;
    }
    & div.cb_label {
      color: #ffffff;
    }
    & div.cb_button {
      display: block;
      width: 100%;
      @media (max-width: 767px) {
        display: none;
      }
    }
    & div.cb_description {
      display: block;
      @media (max-width: 767px) {
        display: none;
      }
    }
    & div.cb_active_arrow {
      display: flex;
    }
    @media (max-width: 767px) {
      padding: 0px;
      height: 160px;
    }
  }
  ${({ theme }) =>
    theme.shape !== 'classic'
      ? `&:focus ~ span,`
      : `&:focus ~ span:last-child,`}
  &:focus ~ .cb_wrapper {
    ${({ theme }) =>
      theme.outline === true
        ? ` outline: ${theme.outlineOnFocus || '1px solid #333'};
            outline-offset: ${theme.outlineOffset || '2px'};
          `
        : `border:  ${theme.borderOnFocus}`};
  }
  &:checked:focus ~ .cb_wrapper {
    & .cb_label {
      margin: 10px 5px;
    }
  }

  &:checked ~ ${ProductCardWrapper} {
    border: 3px solid;
    border-color: ${({ theme }) => theme.checkedBg};
    & ${ProductIconWrapper} {
      background-color: ${({ theme }) => theme.checkedBg};
      border: inherit;
      & ${ProductIcon} {
        display: none;
      }
      & ${CheckMark} {
        display: inline-block;
        color: white;
      }
    }

    & ${QuoteButtonWrapper} {
      border-top: inherit;
      & ${QuoteButton} {
        border: 3px solid;
        border-color: ${({ theme }) => theme.checkedBg};
        background-color: white;
        color: ${({ theme }) => theme.checkedBg};
      }
    }
  }
`

const LabelText = styled.span`
  font-size: 16px;
  margin-left: 2em;
  line-height: ${({ theme }) => theme.lineHeight || 1};
  z-index: 1;
  color: ${({ theme }) => theme.fontColor};
  font-weight: ${({ theme }) => theme.fontWeight};
  font-size: ${({ theme }) => theme.fontSize};
  font: ${({ theme }) => theme.font};
  max-width: 400px;
  min-width: 80px;
  ${({ theme }) =>
    theme.shape !== 'classic' &&
    `
    margin-left: 0;
    display: inline-block;
    text-align: center;
    padding: ${theme.customPadding || '20px'};
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    border: ${theme.border ? theme.border : '1px solid rgba(153,153,153,1)'};
    min-width: 135px;
  `}
  ${({ theme }) =>
    theme.shape === 'oval' &&
    `
    padding: ${theme.customPadding || '16px 20px'};
    border-radius: 25px;
  `}
  ${({ theme }) =>
    (theme.shape === 'rectangle' || theme.shape === 'htmlRadioButton') &&
    `
    border-radius: 4px;
    // changing min-width from 135px to 125px because the tool tip for
    // Gender is going to next line for small screens
    @media (max-width: 384px) {
      min-width: 125px;
    }
  `}
  ${({ theme }) =>
    theme.showCustomInput &&
    `
  padding: 20px 24px;
  padding-left: 33px;
`}
white-space: ${({ theme }) => theme.whiteSpace};
`

const Label = styled.label`
  box-sizing: border-box;
  & * {
    box-sizing: border-box;
    transition: all 300ms ease-in-out;
    ${({ theme }) =>
      theme.shape === 'htmlRadioButton' &&
      `
        transition: background-color 100ms ease-in-out;
      `}
  }

  ${({ theme }) => !theme.disabled && `cursor: pointer;`}
  position: relative;
  display: flex;
  align-items: ${({ theme }) =>
    theme.shape === 'classic' ? theme.alignClassic || 'center' : 'center'};
  margin: ${({ theme }) =>
    theme.shape === 'card_button' ? '2px' : theme.margin || '1em'};
  margin-left: 0;
  ${({ theme: { columns } }) =>
    columns > 0 &&
    `
    flex-basis: calc((100%/${columns}));
    margin-right: 0;`};
  height: ${({ theme }) => theme.height || vars[theme.shape].height};

  ${({ theme }) =>
    theme.shape !== 'classic' &&
    `
      height: ${vars[theme.shape].height};
    `}

  &:hover > ${FakeInput} {
    ${({ theme }) =>
      theme.showCustomInput &&
      `
      z-index:2;
    `}
    background: ${({ theme }) =>
      theme.showCustomInput
        ? !theme.disabled && theme.checkedFg
        : !theme.disabled && theme.checkedBg};

    ${({ theme }) =>
      !theme.disabled &&
      `
        transform: scale(1.1);
        &:after {
          display: block;
        }
      `}
  }

  ${({ theme }) =>
    theme.shape === 'card_columns' &&
    `
    border-radius: 25px;
  `}

  ${({ theme }) =>
    theme.shape !== 'classic' &&
    theme.shape !== 'card_columns' &&
    !theme.disabled &&
    `
  &:hover > span {
    @media (-ms-high-contrast: active) {
      background: yellow;
      color: black
    }

    @-moz-document url-prefix() {
      ${(props) =>
        props.hcEnabled &&
        `
        background: white;
         color: white;
         text-decoration: underline;
         text-decoration-thickness: 5px;
      `}
    }
    background: ${theme.checkedBg};
    color: ${theme.checkedFg};
   border-top:${theme.hasBorderTop ? '3px solid black' : ''};
   
  }

`};
  ${({ theme }) =>
    theme.showCustomInput &&
    !theme.disabled &&
    `
  &:hover > span {
      border:2px solid ${theme.checkedBg};
       box-shadow:inset 0px 0px 0px 1px ${theme.checkedFg};
       box-sizing:border-box;
  }
`}
  ${({ theme }) =>
    theme.shape === 'card' &&
    `
    width: ${theme.labelWidth || 'calc(100% / 3)'} ;
`}
  ${({ theme }) =>
    theme.shape === 'card_button' &&
    `
      overflow: hidden;
      width: 100%;
      max-width: 300px;
      @media (max-width: 767px) {
        max-height: 150px;
        max-width: 114px;
      }
  `}
`

const RadioGroupWrapper = styled.div`
  display: flex;
  position: relative;
  ${({ theme }) => theme.fontFamily && `font-family: ${theme.fontFamily};`}
  justify-content: ${({ theme: { shape } }) =>
    ['card', 'card_button'].includes(shape) ? 'center' : 'normal'};
  flex-direction: ${({ theme }) =>
    theme.orientation === 'rows' ? 'row' : 'column'};
  margin: ${({ theme: { shape } }) =>
    shape === 'card_button' ? 0 : '0.5em 0'};
  ${({ theme: { orientation, shape } }) =>
    orientation === 'rows' &&
    `flex-wrap: ${shape === 'card_button' ? 'nowrap' : 'wrap'};`}
  // this is for yes/no buttons in small screens
  // i.e., when one button is below the other, NAT-1470
  ${({ theme }) =>
    theme.shape === 'oval' &&
    `
    @media (max-width: 460px) {
        & {
          justify-content: center;
        }
    }
    `}
  // this is for gender buttons for small screens
  ${({ theme }) =>
    theme.overlap &&
    theme.orientation !== 'columns' &&
    theme.shape !== 'card' &&
    `
    & ${Label} {
      @media (max-width: 363px) {
        padding: 21px; 
      }
    }
    `}
  ${({ theme }) =>
    theme.overlap &&
    theme.orientation !== 'columns' &&
    theme.shape !== 'classic' &&
    `
    & ${LabelText} {
      border-radius: 0;
    }
    & ${Label} {
      margin: 0.5em 0;
      ${theme.hasBorderTop && 'margin-top: 0.5px'};
      ${theme.overlapWithMargin && 'margin: 10px 0 10px 0;'};
      ${theme.showCustomInput && 'margin: 0.9em 0;'};
      @media (min-width: 361px) and (max-width: 480px) {
        margin: 0.9em 0;
      ${theme.hasBorderTop && 'margin: 0.5px 0'};
        
      }
    }
    & ${Label}:last-of-type ${LabelText} {
      border-bottom-right-radius: ${theme.shape === 'oval' ? '25px' : '4px'};
      border-top-right-radius: ${theme.shape === 'oval' ? '25px' : '4px'};
    }
    & ${Label}:first-child ${LabelText} {
      border-bottom-left-radius: ${theme.shape === 'oval' ? '25px' : '4px'};
      border-top-left-radius: ${theme.shape === 'oval' ? '25px' : '4px'};
    }
 `}
 ${({ theme }) =>
    theme.overlapWithMargin &&
    `
 border:${theme.border};
 border-radius:25px;
 max-width:fit-content;
 & ${LabelText} {
   border-radius:25px;
   border:none;
 }
 & ${Label} {
  height:57px;
  margin:0px;
}
 `}
 ${({ theme }) => theme.hasBorderTop && `margin-top: 0px; margin-bottom: 30px;`}
`

const Icon = styled.img`
  max-width: 30px;
`

const CCInput = styled.input`
  display: none;
  & + span {
    position: absolute;
    top: 50%;
    transform: translate(20px, -50%);
    line-height: ${CCRadioSize};
    height: ${CCRadioSize};
    padding-left: ${CCRadioSize};
    display: block;
    &:not(:empty) {
      padding-left: ${CCRadioSize} + 8;
    }
    &:before,
    &:after {
      content: '';
      width: ${CCRadioSize};
      height: ${CCRadioSize};
      display: block;
      border-radius: 50%;
      left: 0;
      top: 0;
      position: absolute;
    }
    &:before {
      background: ${({ theme }) => theme.fillBg};
      transition: background 0.2s ease,
        transform 0.4s cubic-bezier(0.175, 0.885, 0.32, 2);
    }
    &:after {
      background: #fff;
      transform: scale(0.78);
      transition: transform 0.6s cubic-bezier(0.175, 0.885, 0.32, 1.4);
    }
  }

  &:checked ~ div.wrapper {
    border: 3px solid ${({ theme }) => theme.checkedBg};
  }

  &:checked + span.radio_button {
    &:before {
      transform: scale(1.04);
      background: ${({ theme }) => theme.selectedBgColor};
    }
    &:after {
      transform: scale(0.4);
      transition: transform 0.3s ease;
    }
  }
`

const CCWrapper = styled.div`
  display: flex;
  border: 2px solid #eee;
  min-height: 2em;
  width: 100%;
  border-radius: 8px;
  padding: 1em;
  align-items: center;
  justify-content: flex-start;
`

const CCContentWrapper = styled.div`
  margin-left: 40px;
  width: 100%;
  height: 100%;
`

const CCHeader = styled.div`
  font-size: 20px;
  font-weight: 500;
`

const CCBody = styled.div`
  color: #828282;
  font-size: 20px;
  line-height: 25px;
  max-width: 70%;
`

const IconCardWrapper = styled.div`
  padding: 16px 28px;
  text-align: center;
  background-color: rgba(247, 247, 247, 1);
  height: auto;
  min-height: 64px;
  border: 2px solid
    ${({ checked, theme }) => (checked ? theme.checkedBg : 'transparent')};
  color: ${({ checked, theme }) =>
    checked ? theme.checkedBg : 'rgba(45, 45, 45, 1)'};
  transition: border 100ms ease-in-out;
`

const IconLabelText = styled.span`
  font-weight: ${({ checked }) => (checked ? 600 : 400)};
  transition: font-weight 0ms ease-in-out;
`

const FaCardIcon = styled.div`
  display: flex;
  align-items: center;
  border-radius: 50%;
  background-color: ${({ checked, theme }) =>
    checked ? themes[theme.color].checkedBg : 'rgba(153, 153, 153, 1)'};
  width: 50px;
  height: 50px;
  font-size: 24px;
  color: white;
  justify-content: center;
  margin: auto;
  margin-bottom: 8px;
`

const CBWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  max-height: 224px;
  border-radius: 2px;
  padding: 56px 24px;
  background: #f7f6f4;
  transition: none;
  @media (max-width: 767px) {
    padding: 5px 0;
    height: 136px;
  }
`

const CBTitle = styled.div`
  color: #333333;
  font-size: 28px;
  font-weight: 900;
  letter-spacing: 0px;
  transition: none;
  @media (max-width: 767px) {
    font-size: 20px;
  }
`

const CBSubTitle = styled(CBTitle)`
  font-size: 14px;
  line-height: 24px;
  @media (max-width: 767px) {
    text-align: center;
    margin: 0px 5px;
  }
`

const CBLabel = styled.div`
  color: #333333;
  font-size: 16px;
  font-weight: 900;
  letter-spacing: 0px;
  margin: 15px 20px;
  margin-top: 8px;
  transition: none;
  text-align: center;
  @media (max-width: 767px) {
    text-align: center;
    font-size: 14px;
    margin: 5px 10px;
  }
`

const CBButtonWrapper = styled.div`
  display: none;
  @media (max-width: 1200px) {
    & button {
      font-size: 20px;
    }
  }
  @media (max-width: 850px) {
    & button {
      font-size: 18px;
    }
  }
  @media (max-width: 800px) {
    & button {
      font-size: 16px;
    }
  }
`

const CBBottomButtonWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  max-width: 335px;
  margin: 0 auto 10px;
`

const CBFullButtonWrapper = styled.div`
  width: 100%;
  max-width: 335px;
  display: flex;
  flex-direction: column;
  align-items: center;
  background: #ffffff;
  border-radius: 0px;
  margin: 8px 0;
  padding: 15px 0;
  & button {
    width: 100%;
    max-width: 310px;
  }
`

const CBDescription = styled.div`
  color: #ffffff;
  font-size: 16px;
  font-weight: 300;
  text-align: center;
  line-height: 24px;
  margin-top: 16px;
  display: none;
  text-align: center;
`

const CBActiveArrowWrapper = styled.div`
  width: 100%;
  background: #fff;
  position: absolute;
  bottom: 0;
  display: none;
  justify-content: center;
`

const CBActiveArrow = styled.div`
  width: 0;
  height: 0;
  border-left: 10px solid transparent;
  border-right: 10px solid transparent;
  border-top: 8px solid #00534c;
`

const CBFullDescription = styled(CBDescription)`
  color: #333333;
  display: block;
  @media (min-width: 768px) {
    color: #ffffff;
    display: none;
  }
`

const ContentWrapper = styled.div`
  display: flex;
  align-items: flex-end;
  flex-wrap: wrap;
  justify-content: center;
`

const CardWithHeader = styled.div`
  display: flex;
  flex-direction: column; 
  align-items: center;
  width: 25%;
  margin-left: 17px;
  margin-right: 17px;
`
const CardHeading = styled.span`
  font-size: 14px;
  color: #424242;
  font-family: OpenSans Semi Bold;
`

export {
  Label,
  LabelText,
  Input,
  FakeInput,
  RadioGroupWrapper,
  Icon,
  CardBody,
  CardTitle,
  CardWrapper,
  Value,
  Metric,
  Heading,
  CCWrapper,
  CCContentWrapper,
  CCBody,
  CCHeader,
  CCInput,
  IconCardWrapper,
  IconLabelText,
  FaCardIcon,
  CardArrow,
  CBWrapper,
  CBTitle,
  CBSubTitle,
  CBLabel,
  CBButtonWrapper,
  CBBottomButtonWrapper,
  CBFullButtonWrapper,
  CBDescription,
  CBActiveArrowWrapper,
  CBActiveArrow,
  CBFullDescription,
  Prefix,
  Val,
  ContentWrapper,
  ProductCardDetail,
  ProductIconWrapper,
  Title,
  ProductDescription,
  ProductContent,
  ViewMore,
  QuoteButtonWrapper,
  QuoteButton,
  ProductCardWrapper,
  CheckMark,
  ProductIcon,
  CardWithHeader,
  CardHeading
}
